import React from 'react'
import { Link } from 'react-router-dom'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { FeaturedProductsSection } from 'app/sofia/components/FeaturedProductsSection'

export const FeaturedProducts = () => {
  const staticBlockID = CMS_BLOCK.HOME_FEATURED_PRODUCTS
  const staticBlock = useCmsBlock({
    id: staticBlockID,
    isLazy: false
  })

  if (!staticBlock.content) return null
  const content = staticBlock.content

  const productsParent = document.createElement('div')
  productsParent.innerHTML = content
  const newsElements = productsParent.querySelectorAll('#products')
  const jsonProducts = JSON.parse(newsElements[0].innerHTML)
  const products = Object.keys(jsonProducts).map(product => jsonProducts[product])
  const title = productsParent.getElementsByTagName('h2')?.[0].innerHTML
  const subTitle = productsParent.getElementsByTagName('p')?.[0].innerHTML
  const cta = productsParent.getElementsByTagName('a')?.[0]

  return (
    <FeaturedProductsSection
      title={
        <h2>{title}</h2>
      }
      subTitle={
        <p>{subTitle}</p>
      }
      cta={
        <Link to={cta.pathname}>{cta.innerHTML}</Link>
      }
      items={products}
    />
  )
}
